<div *ngIf="!showLoading" id="customer-complete-profile">

  <form class="form" [formGroup]="completeProfileFormGroup">
    <div class="row">
      <div class="col-12">
        <div class="complete-profile">
          <h2><strong>{{cfetLabels.utf_complete_profile.heading}}</strong></h2>
        </div>
        <div>
          <p class="enterPwdText" [innerHTML]="cfetLabels.utf_complete_profile.enterPasswordSubLabel"></p>
        </div>
      </div>
    </div>

    <div class="row form-row" id="password" [class.error]="(newPassword?.errors &&
     !newPassword.errors.required && errorFlagPArray[0] || cfetService.pwdObj.isErrorCodeArray[0] || isWeekPassword)"
      [ngClass]="(isFocusOn && mobileView) ? 'addExtraPadding' : ''">
      <div class="col-12">
        <label for="input_create_pass">{{cfetLabels.cfet_complete_profile.create_password}}
        </label>
        <div class="inputbox">
          <div class="field-group new-password-input">
            <abs-tooltip id="tooltip" class="field-group abs-tooltip-onfocus">
              <app-password-validation-tooltip id="reset-pwd-tooltip" class="abs-tooltip-onfocus reset-pwd-tooltip"
                [consecutiveFlagFlow]=false [index]=0 (emitedPassword)="emitedPasswordMethodReset($event)"
                (isFocusOn)="isPasswordTooltipExpanded($event)" (change)="changeConfirmPwd($event)">
              </app-password-validation-tooltip>
            </abs-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-row" id="confirm-password" [class.error]="isInvalidPassword || isWeekPassword">
      <div class="col-12">
        <label for="input_confirm_pass">{{cfetLabels.cfet_complete_profile.confirm_password}}</label>
        <div class="field-group noPadding inputbox">
          <input id="confirm_password" name="confirm_password" formControlName="confirmPassword" autocomplete="off"
            tabindex="0" type="password" minlength="8" maxlength="24" restrict-input="restrictPasswordNew"
            [type]="showPwd ? 'text' : 'password'" (change)="changeConfirmPwd($event)" (click)="pwdKeyup($event)"
            (keyup)="pwdKeyup($event)" (blur)="pwdBlur()"
            [ngClass]="(isFocus || confirmPassword.value) ? 'focusOn' : '' " aria-label="Confirm password">
          <span *ngIf="confirmPassword.value" class="pwd_close_icon padRight35" id="cross-icon-pwd0">
            <img *ngIf="confirmPassword.value" id="close" (click)="resetField($event)" (keyup)="resetField($event)"
              src="assets/images/C100_Close_16.png" alt="Close" role="img" tabindex="0" aria-label="icon-close">
            <img *ngIf="confirmPassword.value" id="line" src="assets/images/Line.png" alt="Line" role="img"
              aria-label="icon-line">
          </span>
          <span *ngIf="confirmPassword.value || isFocus"
            [ngClass]="{'pwd_icon_hide': showPwd, 'pwd_icon_show' : !showPwd}" class="padLeft15 marginRt15"
            id="pwd-icon0">
            <img *ngIf="showPwd" id="blue_eye" src="assets/images/Eye_Icon_blue_hide.png" alt="BlueEye" role="img"
              tabindex="0" aria-label="icon-eye-hide" (click)="showHidePassword($event)"
              (keyup)="showHidePassword($event)"
              [ngClass]="(isFocus && !confirmPassword.value) ? 'focusOnBlueEye' : ''">
            <img *ngIf="!showPwd" id="blue_eye" src="assets/images/Eye_Icon_blue.png" alt="BlueEye" role="img"
              tabindex="0" aria-label="icon-eye-show" (click)="showHidePassword($event)"
              (keyup)="showHidePassword($event)"
              [ngClass]="(isFocus && !confirmPassword.value) ? 'focusOnBlueEye' : ''">
          </span>
          <span *ngIf="!confirmPassword.value && !isFocus"
            [ngClass]="{'pwd_icon_hide': showPwd, 'pwd_icon_show' : !showPwd}" id="pwd-icon0"
            (click)="showHidePassword($event)" (keyup)="showHidePassword($event)" class="padLeft15">
            <img *ngIf="showPwd" id="black_eye" src="assets/images/Eye_Icon_black_hide.png" alt="Eye" role="img"
              tabindex="0" aria-label="icon-eye-hide">
            <img *ngIf="!showPwd" id="black_eye" src="assets/images/Eye_Icon_black.png" alt="Eye" role="img"
              tabindex="0" aria-label="icon-eye-show">
          </span>
        </div>
        <div id="account-confirm-err" *ngIf="isInvalidPassword" role="alert" [attr.aria-atomic]="true"
          [ngClass]="{'error-msg' : isInvalidPassword}">
          <em class="icon-badgealert" aria-hidden="true" aria-label="Alert"></em>
          <span id="error_confirm_password">{{cfetMessages.password_mismatch}}</span>
        </div>
        <div id="account-confirm-err" *ngIf="isWeekPassword" role="alert" [attr.aria-atomic]="true"
          [ngClass]="{'error-msg' : isWeekPassword}">
          <em class="icon-badgealert" aria-hidden="true" aria-label="Alert"></em>
          <span id="error_confirm_password">{{cfetMessages.strong_password}}</span>
        </div>
      </div>
    </div>
    <div [ngClass]="(openTooltip &&  !mobileView) ? 'ExtraPadding' : 'zeroPadding'"
      [class.extra30padding]="((newPassword?.errors &&
    !newPassword.errors.required && errorFlagPArray[0] || cfetService.pwdObj.isErrorCodeArray[0] || isWeekPassword) && !mobileView)">
      <div class="row form-row" id="security-question">
        <div class="col-12">
          <div class="field-group">
            <label for="select_security_question">{{cfetLabels.cfet_complete_profile.security_question}}
            </label>
          </div>
          <div class="field-group mt-3">
            <div [ngClass]="questionExpanded ? 'dropdown-opened' : ''">
              <abs-dropdown [drId]="'select_security_question'" [drName]="'securityQuestion'"
                [(dropdownValue)]="SecurityQuestionvalue" formControlName="securityQuestion"
                [optionRepeat]="securityQuestionsList" (dropdownValueChange)="selectQuestions($event)"
                (click)="onClickSecurityQuestion($event)" ngDefaultControl>
              </abs-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="row form-row" id="security-ans"
        [class.error]="securityAnswer.errors && securityAnswer.errors.minlength">
        <div class="col-12">
          <label for="input_security_answer">{{cfetLabels.cfet_complete_profile.security_answer}}</label>
          <div class="inputbox">
            <input id="security_answer" name="security_answer" formControlName="securityAnswer" autocomplete="off"
              tabindex="0" maxlength="20" type="text" restrict-input="securityAnswer" aria-label="Answer">
            <div *ngIf="securityAnswer.errors && securityAnswer.errors.minlength" id="security-answer-error"
              [attr.aria-atomic]="true" role="alert"
              [ngClass]="{'error-msg' : securityAnswer.errors && securityAnswer.errors.minlength}">
              <em class="icon-badgealert" aria-hidden="true" aria-label="Alert"></em>
              <span id="error_security_answer">{{cfetMessages.security_minlenth_three}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row form-row" id="time-zone">
        <div class="col-lg-6 col-12">
          <label for="time_zone">
            {{cfetLabels.cfet_complete_profile.time_zone}}</label>
          <div class="field-group">
            <div [ngClass]="timezoneExpanded ? 'dropdown-opened' : ''">
              <abs-dropdown [drId]="'time_zone'" [drName]="'timeZone'" [(dropdownValue)]="timeZoneValue"
                formControlName="timeZone" [optionRepeat]="timeZoneList" (dropdownValueChange)="selectTimezone($event)"
                (click)="onClickTimeZone($event)"  ngDefaultControl>                
              </abs-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="row" id="confirm-checkbox">
        <div class="col-12">
          <label for="affirm-checkbox" class="checkbox">
            <input id="affirm-checkbox" tabindex="0" type="checkbox" (click)="confirmCheckbox($event)"
              formControlName="termsChecked" (keyup)="confirmCheckbox($event)" [checked]="isChecked" unchecked
              required />
            <em class="skin" tabindex="-1"></em>
            <span>
              <label for="checkboxContent" class="checkboxContent">{{cfetLabels.utf_complete_profile.affirm}}
                <a id="link_terms_condition" class="link_terms_condition" (click)="openTerms($event)"
                  (keyup)="openTerms($event)" role="link" tabindex="0">
                  {{cfetLabels.cfet_complete_profile.terms}}</a>
              </label>
            </span>
          </label>
        </div>
      </div>

      <hr />
      <div class="row no-gutters">
        <div class="col-12 btn-container">
          <a data-dismiss="modal" (click)="cancel($event)" (keyup)="cancel($event)" tabindex="0" type="link"
            id="cancel_link">
            {{cfetButtonLabels.button_labels.cancel}}</a>
          <button type="button" id="btn-submit" (click)="submit($event)" (keyup)="submit($event)"
            class="btn btn-alt btn-medium" tabindex="0" [disabled]="disabledSubmitButton()">
            {{cfetButtonLabels.button_labels.utf_submit}}</button>
        </div>
      </div>
    </div>
  </form>
</div>
<div [ngClass]="showInactivityModal ? 'open-utf-inactivity-modal' : ''">
  <app-customer-inactivity-utf-modal [openModal]="openInactivityModal"
    (closeInactivityModal)="closeInactivityModal($event)">
  </app-customer-inactivity-utf-modal>
</div>

<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>

<div [ngClass]="showCancelModal ? 'open-utf-cancel-modal' : 'hide-cancel-modal'">
  <app-customer-utf-cancel-modal [openModal]="openCancelModal" (closeCancelModal)="closeCancelModal($event)">
  </app-customer-utf-cancel-modal>
</div>